import { useCentralApi, useCurrentUser } from "hooks/shared";

import { IAuditTracePayload } from "models/audit";

const useAuditTrace = () => {
    const fetcher = useCentralApi();

    const writeTrace = async (payload: IAuditTracePayload) => {
        await fetcher('/api/v3/audit/trace', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return writeTrace;
};

export default useAuditTrace;